/**
 * Legacy jQuery accordion (.js-toggle-item/.js-toggle-button/.js-toggle-content).
 *
 * Superseded by component-disclosure.js.
 */
(function () {
  const selectors = {
    container: ".js-toggle-container",
    item: ".js-toggle-item",
    button: ".js-toggle-button",
    content: ".js-toggle-content",
    initialized: ".initialized"
  };

  const attributes = {
    accordionMode: "data-accordion-mode"
  };

  const modifiers = {
    active: "active",
    initialized: "initialized"
  };

  const accordionModes = {
    single: "single",
    multiple: "multiple"
  };

  function initAccordions() {
    const $container = $(selectors.container).not(selectors.initialized);
    const $button = $(selectors.button).not(selectors.initialized);

    if (!$button.length) {
      return null;
    }

    if ($container.length) {
      $container.on("click", selectors.button, toggleAccordion);
      $container.addClass(modifiers.initialized);
      $container.find(selectors.button).addClass(modifiers.initialized);
    } else {
      $button.on("click", toggleAccordion);
      $button.addClass(modifiers.initialized);
    }
  }

  function toggleAccordion() {
    let $accordion = $(this).closest(selectors.item);
    let $accordionButton = $accordion.find(selectors.button);
    let $accordionContent = $accordion.find(selectors.content);

    if (!$accordionContent) {
      return null;
    }

    let $accordionContainer = $accordion.parents(selectors.container);
    $accordion.toggleClass(modifiers.active);
    let expandedState = $accordion.hasClass(modifiers.active);

    // Toggle the aria-expanded state
    $accordionButton.attr('aria-expanded', expandedState.toString());

    if ($accordionContainer.length) {
      let accordionMode = $accordionContainer.attr(
        attributes.accordionMode
      );

      if (accordionMode === accordionModes.single) {
        let $openAccordions = $accordionContainer
          .find(`${selectors.item}.${modifiers.active}`)
          .filter(function (index, el) {
            return el !== $accordion[0];
          });

        $openAccordions.removeClass(modifiers.active);

        $openAccordions
          .find(selectors.content)
          .stop()
          .slideToggle(250, function () {
            $(this).css("height", "");
          });
      }
    }

    $accordionContent.toggleClass(modifiers.active);

    $accordionContent.stop().slideToggle(250, function () {
      $(this).css("height", "");
    });
  }

  initAccordions();

  document.addEventListener("accordion:init", initAccordions);
})();
